import React from 'react'
import '../../assets/scss/elements/_sticky.scss'


const StickyContainerTop = ({ children }) => (
    <div className="sticky-container-top">{children}</div>
  )

export default StickyContainerTop
